export const corsAllowAll = {
  allowAllOrigins: true,
  credentials: true,
  allowedDomains: [/\*/],
};

export const methodsWithoutBody = [
  'get',
  'head',
] as const;

export const knownHeaders = {
  X_HMAC_SIGNATURE: 'X-HMAC-Signature',
  X_API_KEY: 'X-API-Key',
  AUTHORIZATION: 'Authorization',
  CONTENT_TYPE: 'Content-Type',
  ACCEPT: 'Accept',
  SEC_WEBSOCKET_KEY: 'Sec-WebSocket-Key',
} as const;
